import { api } from '../../../App';
import { ReceiptOrder } from '../../../model/ReceiptOrder';
import { fromReceiptOrderToGenerated } from '../../../parsers/to-generated/receiptOrder.parser';

export const orderReceipt = async (data: ReceiptOrder) => {
  return api.submission.apiSubmissionsReceiptPost(fromReceiptOrderToGenerated(data));
};
